import { render, staticRenderFns } from "./Brain3DInteractive.vue?vue&type=template&id=de7b693e&scoped=true"
import script from "./Brain3DInteractive.vue?vue&type=script&lang=js"
export * from "./Brain3DInteractive.vue?vue&type=script&lang=js"
import style0 from "./Brain3DInteractive.vue?vue&type=style&index=0&id=de7b693e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7b693e",
  null
  
)

export default component.exports